import React, { useContext, createContext, FC, ReactNode } from "react";
import { useState } from "react";

interface ForgotPasswordContextProps {
  confirmPassPopup: boolean;
  setConfirmPassPopup: (value: boolean) => void;
  constUserId: string;
  setconstUserId: (value: any) => void;
  userDetails: any[];
  setUserDetails: (value: any[]) => void;
}

const ForgotPasswordContext = createContext<ForgotPasswordContextProps>(
  {} as ForgotPasswordContextProps
);

interface ForgotPasswordProviderProps {
  children: ReactNode;
}

const ForgotPasswordProvider: FC<ForgotPasswordProviderProps> = ({
  children,
}) => {
  const [confirmPassPopup, setConfirmPassPopup] = useState(false);
  const [constUserId, setconstUserId] = useState("");
  const [userDetails, setUserDetails] = useState<any[]>([]);

  return (
    <ForgotPasswordContext.Provider
      value={{
        confirmPassPopup,
        setConfirmPassPopup,
        constUserId,
        setconstUserId,
        userDetails,
        setUserDetails,
      }}
    >
      {children}
    </ForgotPasswordContext.Provider>
  );
};

export const useForgotPasswordContext = () => {
  return useContext(ForgotPasswordContext);
};

export { ForgotPasswordProvider, ForgotPasswordContext };